import { WorklistView } from '../../../../../../services/CaseManagementService';
import { PatientTemplate } from './PatientTemplate';
import { AccountTemplate } from './AccountTemplate';
import { ServiceDateTemplate } from './ServiceDateTemplate';
import { PhysicianTemplate } from './PhysicianTemplate';
import { PayerTemplate } from './PayerTemplate';
import { AdmitTypeTemplate } from './AdmitTypeTemplate';
import { AdmitSourceTemplate } from './AdmitSourceTemplate';

// Template functions for grid columns
export const patientTemplate = (props: WorklistView) => (
  <PatientTemplate name={props.patient} />
);

export const accountTemplate = (props: WorklistView) => (
  <AccountTemplate account={props.account} />
);

export const serviceDateTemplate = (props: WorklistView) => (
  <ServiceDateTemplate dateString={props.serviceDate} />
);

export const physicianTemplate = (props: WorklistView) => (
  <PhysicianTemplate name={props.physician} />
);

export const payerTemplate = (props: WorklistView) => <PayerTemplate payer={props.payer} />;

export const admitTypeTemplate = (props: WorklistView) => (
  <AdmitTypeTemplate admitType={props.admitType} />
);

export const admitSourceTemplate = (props: WorklistView) => (
  <AdmitSourceTemplate source={props.admitSource} />
);
